class NSSBuybox extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {
      form: this.querySelector(`.shopify-product-form`),
      productSelect: this.querySelector(`[name="id"]`),
      quantity: this.querySelector(`[name="quantity"]`),
      planSelect: this.querySelector(`[name="selling_plan"]`),
      stickyATC: this.querySelector(`.nss-buybox__sticky-atc`),
      docEl: document.documentElement,
    };
    this.formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Buybox] Connected.`);

    const backBtnEl = this.querySelector(`[nss-buybox-back-link]`);
    backBtnEl.addEventListener(`click`, (e) => {
      e.preventDefault();
      if (document.referrer != "") {
        window.location = document.referrer;
      } else {
        window.location = "/";
      }
    });

    this.updateURL();

    this.addEventListener(`change`, this.updateSelectedOptions.bind(this));
    this.addEventListener(`change`, this.updateSelectedFrequency.bind(this));
    this.addEventListener(`change`, this.updateURL.bind(this));
    this.addEventListener(`change`, this.updateScroll.bind(this));

    // Did not throttle/debounce as those will cause significant layout shifts.
    // Might still be worthwhile to do so but with a very minimal delay, if any
    // performance issues arise.
    window.addEventListener(`scroll`, this.updateScroll.bind(this), {
      passive: true,
    });
    this.updateScroll();

    // Frequency/plan selection
    const radioEls = this.querySelectorAll(`[name="frequency"]`);
    radioEls.forEach((radioEl) => {
      radioEl.addEventListener(`click`, this.frequencyChange.bind(this));
    }, { passive: true });

    const planSelectEl = this.querySelector(`[name="plan_select"]`);
    if (planSelectEl) {
      planSelectEl.addEventListener(`change`, this.planSelectChange.bind(this));
    }

    const planSelectStickyEls = this.querySelectorAll(
      `[name="plan_select_sticky"]`
    );
    planSelectStickyEls.forEach((planSelectStickyEl) => {
      planSelectStickyEl.addEventListener(
        `change`,
        this.planSelectChange.bind(this)
      );
    });

    // Quantity
    const qtyPlusEls = this.querySelectorAll(`[nss-qty-plus]`);
    qtyPlusEls.forEach((qtyPlusEl) => {
      qtyPlusEl.addEventListener(`click`, this.qtyIncrement.bind(this));
    });

    const qtyMinusEls = this.querySelectorAll(`[nss-qty-minus]`);
    qtyMinusEls.forEach((qtyMinusEl) => {
      qtyMinusEl.addEventListener(`click`, this.qtyDecrement.bind(this));
    });

    // Sticky ATC
    this.initStickyObservers();

    if (this.els.stickyATC) {
      const stickyAtcBtnEls =
        this.els.stickyATC.querySelectorAll(`[nss-btn-atc] button`);
      stickyAtcBtnEls.forEach((stickyAtcBtnEl) => {
        stickyAtcBtnEl.addEventListener(`click`, () => {
          const event = new Event("submit", {
            bubbles: true,
            cancelable: true,
          });
          this.els.form.dispatchEvent(event);
        });
      });
    }

    // Check cart quantity on load and when variant changes
    this.checkCartQuantity();
    this.addEventListener(`change`, this.checkCartQuantity.bind(this));
    
    // Listen for cart updates
    document.addEventListener('cart:updated', this.checkCartQuantity.bind(this));
  }

  updateScroll() {
    const wrapperEl = this.querySelector(`.nss-buybox__summary-wrapper`);
    const summaryEl = this.querySelector(`.nss-buybox__summary`);
    const summaryBottom = wrapperEl.getBoundingClientRect().top + summaryEl.getBoundingClientRect().height;
    const wrapperBottom = wrapperEl.getBoundingClientRect().bottom;
    wrapperEl.classList.remove(`nss-summary-bottom`);
    wrapperEl.classList.remove(`nss-summary-floating`);
    if (summaryBottom > window.innerHeight) return;
    if (wrapperBottom < window.innerHeight) {
      wrapperEl.classList.add(`nss-summary-bottom`);
    }
    else {
      wrapperEl.classList.add(`nss-summary-floating`);
      if (window.innerWidth > 625) {
        summaryEl.style.width = `${wrapperEl.getBoundingClientRect().width}px`;
      }
    }
  }

  updateURL() {
    if (!Shopify.designMode) {
      const url = new URL(window.location.href);
      const searchParams = url.searchParams;
      searchParams.set(`variant`, this.els.productSelect.value);
      window.history.pushState({}, "", url);
    }
  }

  updateDisplayedFlavorSizes(flavor) {
    const sizeGrpEls = this.querySelectorAll(`[nss-size-flavor]`);
    sizeGrpEls.forEach((sizeGrpEl) => {
      sizeGrpEl.classList.remove(`nss-active`);
    });

    const flavorSizeGrpEls = this.querySelectorAll(
      `[nss-size-flavor="${flavor}"]`
    );
    flavorSizeGrpEls.forEach((flavorSizeGrpEl) => {
      flavorSizeGrpEl.classList.add(`nss-active`);
    });
  }

  updateSelectedFlavorSizes(flavor, size) {
    const flavorSizeGrpEls = this.querySelectorAll(
      `[nss-size-flavor="${flavor}"]`
    );
    flavorSizeGrpEls.forEach((flavorSizeGrpEl) => {
      if (flavorSizeGrpEl.querySelector(`input[nss-value]`)) {
        flavorSizeGrpEl.querySelector(
          `input[nss-value="${size}"]`
        ).checked = true;
      } else {
        flavorSizeGrpEl.querySelector(`select`).value = size;
      }
    });
  }

  updateSelectedOption0(handle) {
    if (this.querySelector(`[nss-value="${handle}"]`)) {
      this.querySelector(`[nss-value="${handle}"]`).checked = true;
    }
    if (this.querySelector(`[nss-option-position="0"] select`)) {
      this.querySelector(`[nss-option-position="0"] select`).value = handle;
    }
  }

  updateSelectedOptions(e) {
    if (this.debug) console.log(`[NSS][Buybox] e.target:`, e.target);
    const elName = e.target.getAttribute(`name`);
    if (elName === "frequency") return;
    if (elName === "plan_select") return;
    if (elName === "plan_select_sticky") return;

    let handleArr = [];

    if (e.target === this.els.productSelect) {
      // If productSelect
      // In this case, we can grab the handle and update everybody else.
      const selectedOption =
        e.target.querySelector(`option:checked`).textContent;
      const optionsArr = selectedOption.split(`/`);
      optionsArr.forEach((optionName) => {
        const handle = optionName
          .toLowerCase()
          .replace("- sold out", "")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
        handleArr.push(handle);
      });
      this.updateSelectedOption0(handleArr[0]);
      this.updateDisplayedFlavorSizes(handleArr[0]);
    } else if (elName === "flavor") {
      // If Flavor (Buybox)
      // Change flavor, switch size, update handle.
      const handleFlavor = e.target.getAttribute(`nss-value`);
      this.updateDisplayedFlavorSizes(handleFlavor);
      handleArr.push(handleFlavor);
      const activeSizeEl = this.querySelector(
        `[nss-size-flavor="${handleFlavor}"] input:checked`
      );
      const handleSize = activeSizeEl.getAttribute(`nss-value`);
      handleArr.push(handleSize);
    } else if (e.target.closest(`[nss-size-flavor]`)) {
      // If Flavor + Size (Buybox & Sticky Buybox)
      const handleFlavor = e.target
        .closest(`[nss-size-flavor]`)
        .getAttribute(`nss-size-flavor`);
      handleArr.push(handleFlavor);
      let handleSize;
      if (e.target.hasAttribute(`nss-value`)) {
        handleSize = e.target.getAttribute(`nss-value`);
      } else {
        handleSize = e.target.value;
      }
      handleArr.push(handleSize);
      this.updateSelectedFlavorSizes(handleFlavor, handleSize);
    } else {
      // Handle the "none of the above" situation
      let handle;
      if (e.target.hasAttribute(`nss-value`)) {
        handle = e.target.getAttribute(`nss-value`);
      } else {
        handle = e.target.value;
      }
      handleArr.push(handle);
      this.updateSelectedOption0(handleArr[0]);
    }

    // Update product select
    if (handleArr.length > 0) {
      if (this.debug) console.log(`[NSS][Buybox] handleArr:`, handleArr);
      const handle = handleArr.join(`-`);
      if (this.debug) console.log(`[NSS][Buybox] handle:`, handle);
      const optionEl = this.els.productSelect.querySelector(
        `[nss-variant-handle="${handle}"]`
      );
      this.els.productSelect.value = optionEl.value;
      this.els.productSelect.dispatchEvent(new Event("change"));
      this.swapContent(optionEl.value);
    }
  }

  swapContent(id) {
    const contentEls = this.querySelectorAll(`[nss-variant-id]`);
    contentEls.forEach((contentEl) => {
      contentEl.classList.remove(`nss-active`);
    });
    const showEls = this.querySelectorAll(`[nss-variant-id="${id}"]`);
    showEls.forEach((showEl) => {
      showEl.classList.add(`nss-active`);
    });

    const sectionId = this.getAttribute(`data-section-id`);
    const allData = JSON.parse(
      document.querySelector(`script[id="${sectionId}"]`).textContent
    );
    const data = allData.filter((variant) => variant.id === parseInt(id))[0];
    if (this.debug) console.log(`[NSS][Buybox] data:`, data);

    // Price Updates
    const otpEl = this.querySelector(`[nss-otp]`);
    this.updatePrices(data.compare_at_price, data.price, otpEl);

    const subEl = this.querySelector(`[nss-sub]`);
    this.updatePrices(data.sub_compare_at_price, data.sub_price, subEl);

    // ATC Updates
    const qtyAtcEls = this.querySelectorAll(`[nss-qty-atc]`);
    const atcBtnEls = this.querySelectorAll(`[nss-btn-atc]`);
    const oosBtnEls = this.querySelectorAll(`[nss-btn-oos]`);

    qtyAtcEls.forEach((qtyAtcEl) => {
      qtyAtcEl.style.display = `none`;
      if (data.available) qtyAtcEl.style.display = `flex`;
    });

    atcBtnEls.forEach((atcBtnEl) => {
      atcBtnEl.style.display = `none`;
      if (data.available) atcBtnEl.style.display = `flex`;
    });

    oosBtnEls.forEach((oosBtnEl) => {
      oosBtnEl.style.display = `flex`;
      if (data.available) oosBtnEl.style.display = `none`;
    });

    // Update color scheme
    const prefix = "nss-scheme-";
    const classes = this.className
      .split(" ")
      .filter((c) => !c.startsWith(prefix));
    this.className = classes.join(" ").trim();
    this.classList.add(`nss-scheme-${id}`);

    // Update all other sections
    const sectionEls = document.querySelectorAll(
      `.shopify-section [data-section-id]`
    );
    sectionEls.forEach((sectionEl) => {
      const event = new CustomEvent("pdpUpdate", { detail: id });
      sectionEl.dispatchEvent(event);
    });

    // Check cart quantity when variant changes
    this.checkCartQuantity();
  }

  updatePrices(compare, price, el) {
    if (el) {
      const priceEl = el.querySelector(`[nss-price]`);
      const compareEl = el.querySelector(`[nss-compare]`);

      if (compare > price) {
        compareEl.style.display = `block`;
      } else {
        compareEl.style.display = `none`;
      }

      priceEl.textContent = this.formatter.format(price / 100);
      compareEl.textContent = this.formatter.format(compare / 100);
    }
  }

  updateSelectedFrequency(e) {
    // Update buybox frequency selections
    const buyboxEl = this.querySelector(`[nss-frequency-group]`);
    const otpEl = buyboxEl.querySelector(`[nss-otp] input[type="radio"]`);
    const subEl = buyboxEl.querySelector(`[nss-sub] input[type="radio"]`);
    const freqEl = buyboxEl.querySelector(`[name="plan_select"]`);
    if (subEl && freqEl) {
      if (this.els.planSelect.value === "") {
        otpEl.checked = true;
      } else {
        subEl.checked = true;
        freqEl.value = this.els.planSelect.value;
      }
    }

    // Update sticky frequency selection
    const stickyEls = this.querySelectorAll(`[name="plan_select_sticky"]`);
    stickyEls.forEach((stickyEl) => {
      stickyEl.value = this.els.planSelect.value;
    });

    // Update Buy With Prime
    const bwpEl = this.querySelector(`.bwp-widget-and-separator-container`);
    if (bwpEl) {
      if (subEl && subEl.checked) {
        bwpEl.style.opacity = `0.5`;
        bwpEl.style.pointerEvents = `none`;
      } else {
        bwpEl.style.opacity = `1`;
        bwpEl.style.pointerEvents = `all`;
      }
    }
  }

  frequencyChange(e) {
    const planSelectEl = e.target.closest(`label`).querySelector(`select`);
    if (planSelectEl) {
      const sellingPlanId = planSelectEl.value;
      this.els.planSelect.value = sellingPlanId;
    } else {
      this.els.planSelect.value = "";
    }
  }

  planSelectChange(e) {
    this.els.planSelect.value = e.target.value;
  }

  updateQuantity() {
    const qtyEls = this.querySelectorAll(`[nss-qty]`);
    qtyEls.forEach((qtyEl) => {
      qtyEl.value = this.els.quantity.value;
    });

    // Update Buy With Prime
    if (typeof window.bwp !== "undefined") {
      window.bwp.updateWidget(window.bwp.sku, this.els.quantity.value);
    }
    
    // Check if adding this quantity would exceed limit
    this.checkCartQuantity();
  }

  qtyIncrement(e) {
    const current = parseInt(this.els.quantity.value);
    const displayEl = e.target.parentElement.querySelector(`[nss-qty]`);
    if (current >= 15) {
      this.els.quantity.value = 15;
      return;
    } else {
      displayEl.value = current + 1;
      this.els.quantity.value = current + 1;
    }
    this.updateQuantity();
  }

  qtyDecrement(e) {
    const current = parseInt(this.els.quantity.value);
    const displayEl = e.target.parentElement.querySelector(`[nss-qty]`);
    if (current <= 1) {
      this.els.quantity.value = 1;
      return;
    } else {
      displayEl.value = current - 1;
      this.els.quantity.value = current - 1;
    }
    this.updateQuantity();
  }

  async checkCartQuantity() {
    const variantId = this.els.productSelect?.value;
    if (!variantId) return;

    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await response.json();
      
      if (cart && cart.items) {
        const totalQty = cart.items
          .filter(item => item.variant_id == variantId)
          .reduce((sum, item) => sum + item.quantity, 0);
        
        const maxQty = 15;
        const quantityToAdd = parseInt(this.els.quantity?.value) || 1;
        const totalAfterAdd = totalQty + quantityToAdd;
        
        const messageEls = this.querySelectorAll(`[nss-qty-limit-message]`);
        const atcBtnWrappers = this.querySelectorAll(`[nss-btn-atc]`);
        
        // Check if already at max or would exceed max
        const isAtMax = totalQty >= maxQty;
        const wouldExceed = totalAfterAdd > maxQty;
        
        // Show/hide message
        if (isAtMax || wouldExceed) {
          messageEls.forEach((msgEl) => {
            msgEl.style.display = 'block';
          });
        } else {
          messageEls.forEach((msgEl) => {
            msgEl.style.display = 'none';
          });
        }
        
        // Enable/disable Add to Cart buttons
        atcBtnWrappers.forEach((wrapper) => {
          const button = wrapper.querySelector('button');
          if (button) {
            if (isAtMax) {
              button.disabled = true;
              button.setAttribute('aria-disabled', 'true');
            } else {
              button.disabled = false;
              button.removeAttribute('aria-disabled');
            }
          }
        });
      } else {
        // No cart items, hide message and enable buttons
        const messageEls = this.querySelectorAll(`[nss-qty-limit-message]`);
        const atcBtnWrappers = this.querySelectorAll(`[nss-btn-atc]`);
        
        messageEls.forEach((msgEl) => {
          msgEl.style.display = 'none';
        });
        
        atcBtnWrappers.forEach((wrapper) => {
          const button = wrapper.querySelector('button');
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          }
        });
      }
    } catch (error) {
      if (this.debug) console.error(`[NSS][Buybox] Error checking cart:`, error);
    }
  }

  initStickyObservers() {
    if (!this.els.stickyATC) return;

    const controlsEl = this.querySelector(`.nss-buybox__controls`);
    const footerEl = document.querySelector(`nss-footer`);

    const observerOptions = {
      root: null,
      threshold: 0.1,
    };

    // defaults
    this.controlsInView = true;
    this.footerInView = false;

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.target === controlsEl) {
          this.controlsInView = entry.isIntersecting;
        } else if (entry.target === footerEl) {
          this.footerInView = entry.isIntersecting;
        }

        if (!this.controlsInView && !this.footerInView) {
          this.showStickyBar();
        } else {
          this.hideStickyBar();
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    observer.observe(controlsEl);
    observer.observe(footerEl);
  }

  showStickyBar() {
    this.els.stickyATC.classList.add(`nss-active`);
    this.els.docEl.style.setProperty(`--nss-sticky-atc-pos`, `100px`);
  }

  hideStickyBar() {
    this.els.stickyATC.classList.remove(`nss-active`);
    this.els.docEl.style.setProperty(`--nss-sticky-atc-pos`, `0px`);
  }

  recallHandle() {
    const recallState = window?.Recall;
    if (!recallState) return;

    // Get recall item that matches current variant, if any
    const recallItem = recallState.find((r) => {
      return (
        +r.product_variant.replace("gid://shopify/ProductVariant/", "") ===
        +this.els.productSelect.value
      );
    });

    if (recallItem) {

      // Recall modal session storage handler
      var lsgModalRecallVariantsStorageName = "VITA_COCO_RECALL_VARIANTS";
      var lsgModalRecall = document.querySelector(".lsg-recall-modal");
      var storageRecallVariantsIds = JSON.parse(
        sessionStorage.getItem(lsgModalRecallVariantsStorageName) || "[]"
      );

      if (!storageRecallVariantsIds.includes(+variantId) && lsgModalRecall) {
        // If we haven't shown the modal for this variant, show it
        lsgModalRecall.classList.add("active");
        storageRecallVariantsIds.push(+variantId);
        sessionStorage.setItem(
          lsgModalRecallVariantsStorageName,
          JSON.stringify(storageRecallVariantsIds)
        );
      }
    }
  }
}

let elementName = `nss-buybox`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSBuybox);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}